export default __webpack_public_path__ + "assets/wizard-product-d41f068ab4566c8560129b79259d44bb.svg";